import Action from "./Action";
import Route from "../Main/Route";
import {Coordinate as olCoordinate} from "ol/coordinate";
import {Serialization} from "../Main/Serializer";
import RouteIntermediate from "../Main/RouteIntermediate.js";

export default class RouteCoordinateAddAction implements Action {
    private routeIntermediate: RouteIntermediate|null|false = false;

    constructor(
        readonly route: Route,
        readonly coordinate: olCoordinate,
        readonly addIntermediate: boolean = false,
    ) {
    }

    public getRouteIntermediate(): RouteIntermediate|null {
        if (this.routeIntermediate === false) {
            throw new Error('Tried to obtain uninitialized routeIntermediate');
        }

        return this.routeIntermediate;
    }

    public apply(initial: boolean) {
        const coordinates = this.route.getCoordinates().slice();
        coordinates.push(this.coordinate);
        this.route.setCoordinates(coordinates);

        if (this.routeIntermediate === false) {
            if (this.addIntermediate && this.route.getIntermediates()) {
                this.routeIntermediate = new RouteIntermediate(this.route.getIntermediates(), this.route.getCoordinates().length - 1);
            } else {
                this.routeIntermediate = null;
            }
        }

        if (this.routeIntermediate) {
            this.routeIntermediate.intermediates.addIntermediate(this.routeIntermediate);

            if (!initial) {
                this.routeIntermediate.intermediates.routeSideRoadsUtil.unfocusSideRoad(false);
            }
        }
    }

    public revert() {
        if (this.routeIntermediate) {
            this.routeIntermediate.intermediates.removeIntermediate(this.routeIntermediate);
        }

        const coordinates = this.route.getCoordinates().slice();
        coordinates.splice(coordinates.length - 1, 1);
        this.route.setCoordinates(coordinates);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            route: this.route.id,
            coordinate: this.coordinate,
            addIntermediate: this.addIntermediate,
        };
    }
}
